/* eslint-disable promise/param-names */
/* eslint-disable */
import { USER_REQUEST, USER_ERROR, USER_SUCCESS,USE, USERALL, GETALLUSERS } from '../actions/user';
import { apiCall, api_routes } from '@/utils/api';
import { AUTH_LOGOUT } from '../actions/auth';

const state = {
  status: '', profile: {}, users: '',
};

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
};

const actions = {
  [USERALL]: ({commit, dispatch}, body) => {
    commit(USERALL);
    commit(USER_REQUEST);
  },
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST);
    apiCall({ url: api_routes.user.me })
      .then((resp) => {
        commit(USER_SUCCESS, resp);
      })
      .catch((err) => {
        console.log(err);
        commit(USER_ERROR);
        // if resp is unauthorized, logout, too
        dispatch(AUTH_LOGOUT);
      });
  },
};

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.profile = resp;
  },
  [USER_ERROR]: (state) => {
    state.status = 'error';
  },
  [USERALL]: (state) => {
    state.status = 'loading';
  },
  [GETALLUSERS]: (state) => {
    state.status = 'success';
    state.users = 200;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
